import type {
  CreateTaskRequest,
  TaskDetailDto,
  TaskListItemDto,
  TransitionRequest,
  UpdateTaskRequest,
} from '@ledokol/contracts'
import { api } from './client'

export async function fetchTask(id: string): Promise<TaskDetailDto> {
  const r = await api.get<TaskDetailDto>(`/tasks/${id}`)
  return r.data
}

/** Открытые (не в done-колонке) задачи юзера — экран «Моя работа» + бейдж в сайдбаре. */
export async function fetchMyOpenTasks(userId: string): Promise<TaskListItemDto[]> {
  const r = await api.get<TaskListItemDto[]>('/tasks', {
    params: { assignee: userId, open: 'true' },
  })
  return r.data
}

export async function createTask(
  projectId: string,
  payload: CreateTaskRequest,
): Promise<TaskDetailDto> {
  const r = await api.post<TaskDetailDto>(`/projects/${projectId}/tasks`, payload)
  return r.data
}

export async function transitionTask(
  taskId: string,
  payload: TransitionRequest,
): Promise<void> {
  await api.post(`/tasks/${taskId}/transition`, payload)
}

export async function assignTask(taskId: string, assigneeId: string | null): Promise<void> {
  await api.post(`/tasks/${taskId}/assign`, { assignee_id: assigneeId })
}

export async function setTaskDue(taskId: string, dueAt: string | null): Promise<void> {
  await api.post(`/tasks/${taskId}/due`, { due_at: dueAt })
}

/** PATCH /tasks/:id — title/description/priority/type/tags. assignee/due — отдельные endpoint'ы. */
export async function updateTask(taskId: string, payload: UpdateTaskRequest): Promise<TaskDetailDto> {
  const r = await api.patch<TaskDetailDto>(`/tasks/${taskId}`, payload)
  return r.data
}
